import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { Header, Segment, Icon, Label, List } from 'semantic-ui-react'

const START_TIME_FORMAT = 'YYYY, MMM DD HH:mm:ss.SSSSSS'
const normalizeStartTime = (t) => {
  const _moment = require('moment').default || require('moment')
  return _moment(t, START_TIME_FORMAT)
}

export const JobGroupItem = (props) => {
  const { StartTime:convertTime } =
    props.jobTimeConverters || { StartTime: normalizeStartTime }
  let job_id = props.job_id
  let job = props.job
  let link = `/job_result/${job_id}`

  return (
    <List.Item key={job_id}>
      <List.Content>
        <Label>{convertTime(job.StartTime).fromNow()}</Label>
        <List.Icon name={'calendar'} />
        <Link
          to={link}>[{job_id}] {job.Function} on {'"'}{job.Target}{'"'}</Link>
      </List.Content>
    </List.Item>
  )

}
JobGroupItem.propTypes = {
  jobTimeConverters: PropTypes.objectOf(PropTypes.func),
  job_id: PropTypes.string,
  job: PropTypes.object
}
const JobsLast10Widget = (props) => {
  const jobs = _
    .chain(props.jobs)
    .toPairs()
    .orderBy([job => job[0]], ['desc'])
    .take(10)
    .map((job) => {
      const [job_id, job_data] = job
      return (
        <JobGroupItem
          key={job_id}
          job_id={job_id}
          job={job_data} {...props}/>
      )
    })
    .value()

  return (
    <Segment.Group>
      <Segment basic>
        <Header as='h3'>
          <Icon name='clock' />
          <Header.Content>
            Recent Jobs
          </Header.Content>
        </Header>
      </Segment>

      <Segment basic>
        <List bulleted>{jobs}</List>
      </Segment>

      <Segment basic textAlign='right'>
        <Link to={'/jobs'}>
          View All Jobs <Icon name='arrow circle right' />
        </Link>
      </Segment>
    </Segment.Group>
  )
}
JobsLast10Widget.propTypes = JobGroupItem.propTypes

export default JobsLast10Widget



// WEBPACK FOOTER //
// ./src/components/dashboard/JobLast10.js